module.exports = __webpack_public_path__ + "img/header_right_bg.321ae820.png";